export const UPSELL_DAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

export const getUpsellDaysInRange = (startDate: Date, endDate: Date): string[] => {
    if (!Number.isFinite(startDate.getTime()) || !Number.isFinite(endDate.getTime()) || startDate > endDate) return UPSELL_DAYS;
    const cursor = new Date(startDate);
    const end = new Date(endDate);
    cursor.setHours(0, 0, 0, 0);
    end.setHours(0, 0, 0, 0);
    const includedDays = new Set<string>();
    while (cursor <= end && includedDays.size < 7) {
        includedDays.add(UPSELL_DAYS[(cursor.getDay() + 6) % 7]);
        cursor.setDate(cursor.getDate() + 1);
    }
    return UPSELL_DAYS.filter(day => includedDays.has(day));
};

interface UpsellAttemptRecord {
    eventDate?: string;
    startDate?: string;
    sessionTags?: string[];
}

// Use the browser's local timezone, matching the timezone sent with summary requests.
export const buildUpsellAttemptBuckets = (engagements: readonly UpsellAttemptRecord[] = []) => {
    const days: Record<string, number> = {};
    const hours: Record<string, number> = {};
    engagements.forEach(engagement => {
        const attempts = (engagement.sessionTags || []).filter(tag => tag.toUpperCase() === 'UPSELL_ATTEMPTED').length;
        const timestamp = engagement.eventDate || engagement.startDate;
        if (!attempts || !timestamp) return;
        const date = new Date(timestamp);
        if (!Number.isFinite(date.getTime())) return;
        const day = UPSELL_DAYS[(date.getDay() + 6) % 7];
        const hour = String(date.getHours());
        days[day] = (days[day] || 0) + attempts;
        hours[hour] = (hours[hour] || 0) + attempts;
    });
    return { days, hours };
};
